import React from 'react';
import { Box } from '@material-ui/core';
import styles from './style.module.scss';

const GreyDivider: React.FC = () => {
  return (
    <Box className={styles.divider} />
  );
};

export default GreyDivider;
